export default __webpack_public_path__ + "assets/images/88e7de34bc9f40d6dfb86585c07a5ae8.png";